import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, map } from 'rxjs';
import { AppService } from '@ui-components/services';
import { IProfile, IResponse } from '@interfaces/index';


export const RoleGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const app_service = inject(AppService);
  const roles = route.data['roles'] as number[];

  return app_service.getProfile().pipe(
    map(
      (response: IResponse<IProfile>) => {
        return roles.includes(response.data.role_id);
      }
    )
  )
  

}
